import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/translation/languages/translation.languages.query.gql"
import type {
  TranslationLanguagesQuery,
  TranslationLanguagesQueryVariables,
} from "@/v2-backoffice-client/translation/languages/__types__/translation.languages.query"

type Options = QueryHookOptions<
  TranslationLanguagesQuery,
  TranslationLanguagesQueryVariables
>

export function useTranslationLanguagesQuery(options?: Options) {
  return useQuery<
    TranslationLanguagesQuery,
    TranslationLanguagesQueryVariables
  >(query, options)
}
